module.exports = __webpack_public_path__ + "static/websiteheader_applications-879b2f39a189e1bf6f485d3c63c7525a.jpg";